import React from 'react';
import { FiPhone, FiMapPin, FiFile } from "react-icons/fi";
import { useTranslation } from 'react-i18next';
import './about.css'

const About8 = () => {
    const { t, i18n } = useTranslation();
    return (
        <div className="about-style-5 rn-section-gapBottom noBottom">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row row--0 about-wrapper align-items-center theme-shape">
                            <div className="col-lg-6">
                                <div className="thumbnail">
                                    <img src="./images/about/Ashley.png" alt="About Images" />
                                </div>
                            </div>
                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                <div className="content">
                                    <div className="inner">
                                        {/* <h4 className="title">I'm Web Dedeloper</h4> */}
                                        <p> {t("120")}</p>
                                        <p> {t("121")}</p>
                                        <p> {t("122")}</p>
                                        <p> {t("123")}</p>

                                        <div className="download-button mt--20">
                                            {/* <a className="btn-read-more" href="#"><span>Download My CV</span></a> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default About8;